export default __webpack_public_path__ + "static/media/polygon.8da53a52.svg";